import axios from 'axios';

const request = axios.create({
  responseType: "json",
  headers: {
    "Content-Type": "application/json"
  },
  timeout: 10 * 1e3
});
request.interceptors.request.use(
  (config) => {
    var _a;
    config.withCredentials = (_a = config.url) == null ? void 0 : _a.includes("/customer");
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
request.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    throw error;
  }
);

export { request as default };
//# sourceMappingURL=request.mjs.map
